import { render, staticRenderFns } from "./ExplanationType2.vue?vue&type=template&id=514f552d&"
import script from "./ExplanationType2.vue?vue&type=script&lang=js&"
export * from "./ExplanationType2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports